import React from 'react';
export function TransformationSection() {
  return <section className="bg-white py-10 px-4 sm:px-6 lg:px-8" data-id="element-194">
      <div className="max-w-4xl mx-auto" data-id="element-195">
        <h2 className="font-serif text-3xl sm:text-4xl font-black text-center text-[#1A1A1A] mb-6" data-id="element-196">
          🔄 Antes vs Después
        </h2>

        <div className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-197">
          {/* Before Card */}
          <div className="bg-red-50/50 rounded-2xl p-4 sm:p-6 border border-red-100 shadow-lg relative overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-198">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-red-400" data-id="element-199"></div>
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-xl mb-4 shadow-sm mx-auto" data-id="element-200">
              ❌
            </div>
            <h3 className="text-lg sm:text-xl font-black text-red-800 mb-4 text-center" data-id="element-201">
              Antes
            </h3>
            <ul className="space-y-2 text-sm sm:text-base font-medium text-gray-700" data-id="element-202">
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-203">
                <span className="text-red-500 mr-2 text-base" data-id="element-204">✕</span>Compras
                sin saber qué comes
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-205">
                <span className="text-red-500 mr-2 text-base" data-id="element-206">✕</span>Dependes
                del supermercado
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-207">
                <span className="text-red-500 mr-2 text-base" data-id="element-208">✕</span>Intentas y
                fallas
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-209">
                <span className="text-red-500 mr-2 text-base" data-id="element-210">✕</span>No sabes
                por dónde empezar
              </li>
            </ul>
          </div>

          {/* After Card */}
          <div className="bg-garden-bg rounded-2xl p-4 sm:p-6 border border-garden-medium/30 shadow-xl relative overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-211">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-garden-medium" data-id="element-212"></div>
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-xl mb-4 shadow-sm mx-auto" data-id="element-213">
              ✅
            </div>
            <h3 className="text-lg sm:text-xl font-black text-garden-dark mb-4 text-center" data-id="element-214">
              Después
            </h3>
            <ul className="space-y-2 text-sm sm:text-base font-bold text-garden-dark" data-id="element-215">
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-216">
                <span className="text-garden-medium mr-2 text-base" data-id="element-217">✓</span>
                Produces tus propios alimentos
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-218">
                <span className="text-garden-medium mr-2 text-base" data-id="element-219">✓</span>
                Sabes lo que consumes
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-220">
                <span className="text-garden-medium mr-2 text-base" data-id="element-221">✓</span>
                Huerta funcionando
              </li>
              <li className="flex items-center bg-white p-2.5 rounded-xl shadow-sm" data-id="element-222">
                <span className="text-garden-medium mr-2 text-base" data-id="element-223">✓</span>
                Disfrutas el proceso
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}